import React from "react"
import PropTypes from "prop-types"

import "./Drawer.scss"


export function Drawer(props) {
  let { children, open, ...otherProps } = props
  return (
    <div {...otherProps} className={`drawer drawer--${open ? "open" : "closed"}`}>
      <div className="drawer__inner">
        {children}
      </div>
    </div>
  )
}


Drawer.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node,
}

export default Drawer
